import { ICurrencyCount, IGameItemData } from 'helpers/interfaces';

export interface IGameItemFullData extends IGameItemData {
    currencies: number;
}

export const addCurrencyCountsToGames = (
    games: IGameItemData[] = [],
    configs: ICurrencyCount[] = [],
): IGameItemFullData[] => {
    const currencyCounts = new Map(
        configs.map((config: ICurrencyCount) => [config.gameId, config.currencyCount]),
    );

    return games.map((game: IGameItemData) => ({
        ...game,
        currencies: currencyCounts.get(game.id) || 0,
    }));
};
